import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CounselorSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
`;

const Languages = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.27;
`;

const Location = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.27;
`;

const ProfileCard = styled.div`
  width: 450px;
  text-align: center;
  margin: 10px 20px;
`;

const ProfileImageWrap = styled.div`
  width: 450px;
  transition: scale 0.3s ease;
  overflow: hidden;
`;

const ProfileImage = styled.img`
  border-radius: 10px;
  transition: filter 0.3s ease, scale 0.3s ease;
  scale: 1;
  object-fit: cover;
  object-position: 0 ${(props) => (props.profilePosition ? `${props.profilePosition}` : '0')};
`;

const ScheduleLink = styled.a`
  color: #5e8a64;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;

  position: relative;
  padding-right: 10px;
  cursor: pointer;
  text-decoration: none;
`;

const CounselorExpertise = styled.div`
  font-size: 24px;
  line-height: 1.3;
  font-weight: bold;
  color: #5e8a64;
`;

const CounselorName = styled.div`
  font-size: 24px;
  line-height: 1.3;
  font-weight: bold;
`;

const CounselorTitle = styled.div`
  font-family: Raleway;
  font-size: 20px;
  line-height: 1.3;
  color: black;
`;

const Tagline = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.27;
`;

const CounselorSlide = ({ counselor, header }) => {

  return (
      <CounselorSection>
        {counselor !== null ? (
          <ProfileCard>
            <CounselorExpertise>{header}</CounselorExpertise>
            <CounselorName>{counselor.name}</CounselorName>
            <CounselorTitle>{Array.isArray(counselor.qualifications) ? (counselor.qualifications[0]+', '+counselor.qualifications[1]) : (counselor.qualifications)}</CounselorTitle> 
            <ProfileImageWrap>
              <ProfileImage
                src={`/images/counselors/profile-placeholders/${counselor.profile}`}
                alt={counselor.name}
                profilePosition={counselor.profilePosition}
              />
            </ProfileImageWrap>
            <Languages>Languages: {Array.isArray(counselor.languages) ? (counselor.languages[0]+', '+counselor.languages[1]) : (counselor.languages)}</Languages>
            <Location>Location: {counselor.location}</Location>
            <Tagline>{counselor.tagline}</Tagline>
            Schedule me:&nbsp;&nbsp;
            <ScheduleLink target="_blank" href="sms:+15418180009">Text</ScheduleLink>
            <ScheduleLink target="_blank" href="tel:+15418180009">Call</ScheduleLink>
            <ScheduleLink target="_blank" href="/contact">Email</ScheduleLink>    
        </ProfileCard>
        ) : (<div><p>ERROR: No counselor item found.</p></div>)}
      </CounselorSection>
  );
};

export default CounselorSlide;
